    
import {addToChainAfter, addToChainBefore, HasOnError, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    ApiParameter,   
} from "@insite/client-framework/Services/ApiService";

import {chain,DispatchCompleteLoadShipTo,PopulateApiParameter,SendDataToApi} from "@insite/client-framework/Store/Data/ShipTos/Handlers/UpdateShipTo";
// import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

// this will enable HMR for custom handlers

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
addToChainBefore(chain, PopulateApiParameter, props => {
     const deleteShipToProps=props;
     deleteShipToProps.parameter.shipTo.properties={"isArchived":props.parameter.additionalQueryStringParameters?.canDelete};

    props.apiParameter = deleteShipToProps.parameter;

});

